import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import Error404 from '../../assets/images/NotFound/error-404.svg';

const styles = theme => ({
  container: {
    minHeight: '100vh',
    height: 'auto',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '450px',
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
});

const NotFound = ({ classes }) => (
  <Grid container className={classes.container} alignContent="center">
    <Grid item xs={12}>
      <img src={Error404} alt="Erro 404" className={classes.image} />
    </Grid>
    <Grid item xs={12}>
      <Typography align="center" variant="h5">
        Oops! Página não encontrada
      </Typography>
      <Typography align="center" variant="body1" color="textSecondary" paragraph>
        Desculpa, a página que você está procurando não existe.
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Button type="submit" variant="contained" color="primary" className={classes.button} component={Link} to="/">
        VOLTAR PARA A PÁGINA INICIAL
      </Button>
    </Grid>
  </Grid>
);

NotFound.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotFound);
